  <template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>远程预付费</el-breadcrumb-item>
      <el-breadcrumb-item>拉合闸规则设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form  :inline="true">
      <el-form-item v-if="user.username == 'admin'" label="部门">
        <el-select v-model="depId"   placeholder="请选择"  size="small" @change="changeDept">
           <el-option
             v-for="item in deptData"
             :key="item.id"
             :label="item.departmentName"
             :value="item.id">
           </el-option>
         </el-select>
      </el-form-item>

    </el-form>

    <el-tabs type="border-card" @tab-click="tabChange">
      <el-tab-pane label="拉闸时间点规则">
        <el-button @click="handelAddDateRule" style="margin-bottom: 10px;" type="primary" size="small">添加</el-button>
        <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
          style="width: 100%;" stripe :height="tableHeight" :header-cell-style="this.$store.state.headerCss">
          <el-table-column align="center" type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column prop="instant" label="时间点">
          </el-table-column>

          <el-table-column label="是否是部门默认规则">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-if="scope.row.defaultFlag">是</el-tag>
              <el-tag size="small" type="info" v-if="!scope.row.defaultFlag">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handelDetailDateRule(scope.row)">编辑</el-button>
            
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 2"  @click="handelDateRuleWallet(scope.row)">绑定钱包</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 1"  @click="handelDateRuleMeter(scope.row)">绑定计量点</el-button>
              <el-button type="danger" size="mini" @click="handelDeleRule(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="dateRuleGet" @callFather="handelSjPage"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="拉闸阈值规则">
        <el-button @click="handelAddYuZhi" style="margin-bottom: 10px;" type="primary" size="small">添加</el-button>
        <el-table size="small" :height="tableHeight" :data="yuZhiList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
          style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
          <el-table-column align="center" type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column prop="threshold" label="阈值">
          </el-table-column>

          <el-table-column label="是否是部门默认规则">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-if="scope.row.defaultFlag">是</el-tag>
              <el-tag size="small" type="info" v-if="!scope.row.defaultFlag">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handelYuZhi(scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 2"  @click="handelDateRuleWallet(scope.row)">绑定钱包</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 1"  @click="handelDateRuleMeter(scope.row)">绑定计量点</el-button>
              <el-button type="danger" size="mini" @click="handelDeleyuZhi(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>


        <Pagination v-bind:child-msg="yuZhiGet" @callFather="handelYzPage"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="抄表时间点规则">
        <el-button @click="handelAddChaobiao" style="margin-bottom: 10px;" type="primary" size="small">添加</el-button>
        <el-table :height="tableHeight" size="small" :data="chaoBiaoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
          style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
          <el-table-column align="center" type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column prop="instant" label="时间点">
          </el-table-column>

          <el-table-column label="是否是部门默认规则">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-if="scope.row.defaultFlag">是</el-tag>
              <el-tag size="small" type="info" v-if="!scope.row.defaultFlag">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handelChaobiaoDetail(scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 2"  @click="handelDateRuleWallet(scope.row)">绑定钱包</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 1"  @click="handelDateRuleMeter(scope.row)">绑定计量点</el-button>
              <el-button type="danger" size="mini" @click="handelDeleChaobiaoRule(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="chaoBiaoGet" @callFather="handelCbPage"></Pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加拉闸时间点规则 -->
    <el-dialog :title="DateTitle" :visible.sync="dateFormVisible" width="35%" :close-on-click-modal="false">
    	<el-form label-width="150px" :model="dateFrom"  ref="editForm">
        <el-form-item  label="当前部门:" v-if="user.username == 'admin'">
        	<el-select v-model="dateFrom.departmentId"   placeholder="请选择"  disabled  size="small">
        	   <el-option
        	     v-for="item in deptData"
        	     :key="item.id"
        	     :label="item.departmentName"
        	     :value="item.id">
        	   </el-option>
        	 </el-select>
        </el-form-item>
        <el-form-item label="时间:">
          <el-time-select
            size="small"
            v-model="dateFrom.instant"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30'
            }"
            placeholder="选择拉闸时间">
          </el-time-select>
        </el-form-item>
        <el-form-item label="是否是部门默认规则:" v-if="depId != 0">
          <el-radio v-model="dateFrom.defaultFlag" :label="true">是</el-radio>
          <el-radio v-model="dateFrom.defaultFlag" :label="false">否</el-radio>
        </el-form-item>
    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="dateFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveDateRule">保存</el-button>
    	</div>
    </el-dialog>

    <el-dialog title="绑定钱包" :visible.sync="setFormVisible" width="45%"  :close-on-click-modal="false">
    	<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddWallet">添加</el-button>
    	<el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindWallet"  :disabled="!selectWallet.length" >删除</el-button>
    	<div style="line-height: 30px;">当前绑定的绑定钱包</div>
    	<el-table size="small" :data="walletList" height="500px" border  @selection-change="getDeleWalletIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="钱包名称" prop="walletName"></el-table-column>
    	</el-table>
    	<div style="line-height: 40px;">共计:{{walletList.length}}</div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='setFormVisible = false'>关闭</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
    	</div>
    </el-dialog>

    <el-dialog title="选择钱包" :visible.sync="walletVisible" width="45%" :close-on-click-modal="false">
      <el-form  :inline="true">

        <el-form-item >
          <el-input style="width: 100%;" size="small" v-model="formInline.walletName" placeholder="请输入钱包名称"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="getAllWalletList">搜索</el-button>
        </el-form-item>
      </el-form>
    	<el-table size="small" v-loading="walletLoad" :data="allWalletList" height="500px" border  @selection-change="getwalletIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="钱包名称" prop="walletName"></el-table-column>


    	</el-table>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='walletVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveBindWallet">保存</el-button>
    	</div>
    </el-dialog>


    <!-- 添加拉闸阈值规则 -->
    <el-dialog :title="DateTitle" :visible.sync="yuZhiFormVisible" width="35%" :close-on-click-modal="false">
    	<el-form label-width="150px"  :model="yuZhiFrom"  ref="editForm">
        <el-form-item  label="当前部门:" v-if="user.username == 'admin'">
        	<el-select v-model="depId"   placeholder="请选择"  disabled  size="small">
        	   <el-option
        	     v-for="item in deptData"
        	     :key="item.id"
        	     :label="item.departmentName"
        	     :value="item.id">
        	   </el-option>
        	 </el-select>
        </el-form-item>
        <el-form-item label="阈值:">
          <el-input size="small" v-model="yuZhiFrom.threshold" placeholder="请输入拉闸阈值"></el-input>
        </el-form-item>
        <el-form-item label="是否是部门默认规则:" v-if="depId != 0">
          <el-radio v-model="yuZhiFrom.defaultFlag" :label="true">是</el-radio>
          <el-radio v-model="yuZhiFrom.defaultFlag" :label="false">否</el-radio>
        </el-form-item>
    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="yuZhiFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveYuzhi">保存</el-button>
    	</div>
    </el-dialog>


    <!-- 添加抄表时间点规则 -->
    <el-dialog :title="DateTitle" :visible.sync="chaoBiaoFormVisible" width="35%" :close-on-click-modal="false">
    	<el-form label-width="150px" :model="chaobaioFrom"  ref="editForm">
        <el-form-item  label="当前部门:" v-if="user.username == 'admin'">
        	<el-select v-model="depId"   placeholder="请选择"  disabled  size="small">
        	   <el-option
        	     v-for="item in deptData"
        	     :key="item.id"
        	     :label="item.departmentName"
        	     :value="item.id">
        	   </el-option>
        	 </el-select>
        </el-form-item>
        <el-form-item label="时间:">
          <el-time-select
            size="small"
            v-model="chaobaioFrom.instant"
            :picker-options="{
              start: '00:00',
              step: '00:60',
              end: '23:30'
            }"
            placeholder="选择抄表时间">
          </el-time-select>
        </el-form-item>
        <el-form-item label="是否是部门默认规则:" v-if="depId != 0">
          <el-radio v-model="chaobaioFrom.defaultFlag" :label="true">是</el-radio>
          <el-radio v-model="chaobaioFrom.defaultFlag" :label="false">否</el-radio>
        </el-form-item>
    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="chaoBiaoFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveChaoBiao">保存</el-button>
    	</div>
    </el-dialog>

    <el-dialog title="绑定计量点" :visible.sync="bindFormVisible" width="45%"  :close-on-click-modal="false">
    	<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddMeter">添加</el-button>
    	<el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindMeter"  :disabled="!selectMeter.length" >删除</el-button>
    	<div style="line-height: 30px;">当前绑定的计量点</div>
    	<el-table size="small" :data="meterList" height="500px" border v-loading="loadWallet"  @selection-change="getDeleMeterIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
    	</el-table>
    	<div style="line-height: 40px;">共计:{{meterList.length}}</div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='bindFormVisible = false'>关闭</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
    	</div>
    </el-dialog>


    <el-dialog title="选择计量点" :visible.sync="meterVisible" width="45%" :close-on-click-modal="false">
      <el-form  :inline="true">

        <el-form-item >
          <el-input style="width: 100%;" size="small" v-model="getMeter.meterPointName" placeholder="请输入计量点名称"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="getAllMeterList">搜索</el-button>
        </el-form-item>
      </el-form>
    	<el-table size="small" v-loading="walletLoad" :data="allMeterList" height="500px" border  @selection-change="getMeterIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>

    	</el-table>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='meterVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveBindMeter">保存</el-button>
    	</div>
    </el-dialog>



  </div>

</template>

<script>
  import Pagination from '../../components/Pagination'
  import { getDepartmentTerminalInfoLis,getDepartmentIdByMeterInfos} from '../../api/energyMG'
  import {
    add_meter_cut_instant_rule,
    list_meter_cut_instant_rule,
    update_meter_cut_instant_rule,
    del_meter_cut_instant_rule,
    walletSelectByDptId2,
    meter_cut_instant_rule_bind_wallet,
    mmeter_cut_instant_rule_bind_wallet,
    meter_cut_instant_rule_unbind_wallet,
    mmeter_cut_instant_rule_unbind_wallet,
    meter_threshold_instant_rule_unbind_wallet,
    mmeter_threshold_instant_rule_unbind_wallet,
    add_meter_cut_threshold_rule,
    list_meter_cut_threshold_rule,
    del_meter_cut_threshold_rule,
    update_meter_cut_threshold_rule,
    add_meter_recording_rule,
    list_meter_recording_rule,
    update_meter_recording_rule,
    del_meter_recording_rule,
    meter_threshold_instant_rule_bind_wallet,
    mmeter_threshold_instant_rule_bind_wallet,
    meter_recording_rule_bind_wallet,
    mmeter_recording_rule_bind_wallet,
    meter_recording_rule_unbind_wallet,
    mmeter_recording_rule_unbind_wallet,
    list_wallet_by_rule,
    list_prepaid_department,
    list_meter_info_by_rule

  } from '../../api/payMG'

  export default {
    data() {
      return {
        deptType:-1,
        dataList: [],
        allMeterList:[],
        selectMeter:[],
        chaoBiaoList:[],
        walletVisible:false,
        loading: false,
        setFormVisible:false,
        user:{},
        meterList:[],
        curId:'',
        loadWallet:false,
        depId:"",
        selectWallet:[],
        walletIds:[],
        deptData:[],
        walletList:[],
        meterVisible:false,
        dateFormVisible:false,
        getMeter:{
          meterPointName:"",
          depId:"",
        },
        dateFrom:{
          defaultFlag:false,
          departmentId:0,
          instant:"15:00"
        },

        chaobaioFrom:{
          defaultFlag:false,
          departmentId:0,
          instant:"15:00"
        },
        yuZhiFrom:{
          defaultFlag:false,
          departmentId:0,
          threshold:0
        },
        dateRuleGet:{
          currentPage:1,
          pageSize:10,
          total:0,
          departmentId:0
        },
        bindFormVisible:false,
        yuZhiGet:{
          currentPage:1,
          pageSize:10,
          total:0,
          departmentId:0
        },

        chaoBiaoGet:{
          currentPage:1,
          pageSize:10,
          total:0,
          departmentId:0
        },

        yuZhiList:[],
        DateTitle:"添加",
        setLoading:false,
        walletLoad:false,
        allWalletList:[],
        formInline: {
          depId: '',
          currentPage: 1,
          pageSize: 99999,
          total:0,
          walletName: "",
        },
        dataType:0,
        dtype:['CUT_INSTANT','CUT_THRESHOLD','RECORDING_INSTANT' ],

        yuZhiFormVisible:false,
        tableHeight:0,
        chaoBiaoFormVisible:false,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 360
      })
    },
    created() {
       this.user = JSON.parse(sessionStorage.getItem('userdata'))
       this.getJzData()
    },
    components: {
      Pagination
    },
    methods: {

      tabChange(e){
        this.dataType = e.index
        if(e.index == '0'){
          this.getDateRule()
        }else if(e.index == '1'){
          this.getYuZhi()
        }else{
          this.getChaobiao()
        }
      },

      handelDateRuleMeter(row){
        this.bindFormVisible = true
        this.curId = row.id
        this.getMeterListByRuleId()
      },

      //解绑计量点
      removeBindMeter(){
        this.setLoading = true
        let param = {
          ruleId:this.curId,
          meterInfoIds:this.selectMeter.map(item => item.id)
        }


        if(this.dataType == 0){
          mmeter_cut_instant_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
               this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }else if(this.dataType == 1){
          mmeter_threshold_instant_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }else{

          mmeter_recording_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }
      },




      getMeterListByRuleId(){

        let param = {
          ruleType:this.dataType == 0 ? 'ARREAR_NOTIFY' : 'BALANCE_NOTIFY',
          ruleId:this.curId
        }

         if(this.dataType == 0){
           param.ruleType = 'CUT_INSTANT'
         }else if(this.dataType == 1){
           param.ruleType = 'CUT_THRESHOLD'
         }else{
           param.ruleType = 'RECORDING_INSTANT'
         }

        list_meter_info_by_rule(param).then(res => {

          if(res.status == 1){
            this.meterList = res.data
          }
        })
      },


      //绑定计量点
      saveBindMeter(){
        this.setLoading = true
        let param = {
          ruleId:this.curId,
          meterInfoIds:this.meterIds.map(item => item.id)
        }




        if(this.dataType == 0){

          mmeter_cut_instant_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.meterVisible = false
              this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }else if( this.dataType == 1 ){



          mmeter_threshold_instant_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.meterVisible = false
              this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }else{
          mmeter_recording_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.meterVisible = false
              this.getMeterListByRuleId()

            }else{
              this.$message.error(res.msg)
            }
          })
        }
      },



      handelAddMeter(){
        this.meterVisible = true
        this.getAllMeterList()

      },
      getAllMeterList(){
        this.walletLoad = true
        this.getMeter.depId = this.depId
        getDepartmentIdByMeterInfos(this.getMeter).then(res => {
          this.walletLoad = false
          if(res.status == 1){
            this.allMeterList = res.data
          }
        })
      },

   



      handelSjPage(parm){
        this.dateRuleGet.currentPage = parm.currentPage
        this.dateRuleGet.pageSize = parm.pageSize

        this.getDateRule()
      },
      handelYzPage(parm){
        this.yuZhiGet.currentPage = parm.currentPage
        this.yuZhiGet.pageSize = parm.pageSize
        this.getYuZhi()
      },

      handelCbPage(parm){
        this.chaoBiaoGet.currentPage = parm.currentPage
        this.chaoBiaoGet.pageSize = parm.pageSize
        this.getChaobiao()
      },

      getJzData:function(){
        list_prepaid_department().then(res => {
          if(res.status == 1){

            this.deptData = res.data

            this.depId = res.data[0].id
            this.dateFrom.departmentId = this.depId
            this.dateRuleGet.departmentId = this.depId
            this.yuZhiFrom.departmentId = this.depId
            this.yuZhiGet.departmentId = this.depId
            this.chaoBiaoGet.departmentId = this.depId
            this.chaobaioFrom.departmentId = this.depId


            this.deptType = res.data[0].payType

            if(this.depId == 0){
              this.dateFrom.defaultFlag = true
              this.chaobaioFrom.defaultFlag = true
              this.yuZhiFrom.defaultFlag = true
            }
            this.getDateRule()


          }
          else{
            this.$message.error(res.msg)
          }
        })
      },


      getDateRule(){
        this.loading = true
        list_meter_cut_instant_rule(this.dateRuleGet).then(res =>{
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.content

            this.dateRuleGet.total = res.data.totalElements

          }
        })

      },

      changeDept(e){
        this.dateRuleGet.departmentId = this.depId
        this.dateFrom.departmentId = this.depId
        this.yuZhiGet.departmentId = this.depId
        this.yuZhiFrom.departmentId = this.depId
        this.chaoBiaoGet.departmentId = this.depId
        this.chaobaioFrom.departmentId = this.depId


        this.deptType = this.deptData.filter(item => item.id == e)[0].payType




        if(this.depId == 0){
          this.dateFrom.defaultFlag = true
          this.yuZhiFrom.defaultFlag = true
          this.chaobaioFrom.defaultFlag = true
        }else{
          this.dateFrom.defaultFlag = false
          this.yuZhiFrom.defaultFlag = false
          this.chaobaioFrom.defaultFlag = false
        }



        if(this.dataType == 0){
          this.getDateRule()
        }else if(this.dataType == 1){
          this.getYuZhi()
        }else{
          this.getChaobiao()
        }

      },

      handelAddDateRule(){
        this.DateTitle = '添加'
        this.dateFormVisible = true
        this.dateFrom.instant = '15:00'

        this.dateFrom.id = ''
        if( this.depId != 0  ){
           this.dateFrom.defaultFlag = false
        }
      },

      handelDetailDateRule( row){
        this.DateTitle = '修改'
        this.dateFormVisible = true
        this.dateFrom.defaultFlag = row.defaultFlag
        this.dateFrom.instant = row.instant
        this.dateFrom.id = row.id

      },


      saveDateRule(){
        if(this.DateTitle == '添加'){
          this.addDateRule()
        }else{
          this.upateDateRule()
        }
      },

      addDateRule(){
        this.setLoading = true



        add_meter_cut_instant_rule(this.dateFrom).then(res => {
          this.setLoading = false
          if(res.status == 1){
            this.$message.success('操作成功!')
            this.dateFormVisible = false
            this.getDateRule()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      upateDateRule(){
        this.setLoading = true
        update_meter_cut_instant_rule(this.dateFrom).then(res => {
          this.setLoading = false
          if(res.status == 1){
            this.$message.success('操作成功!')
            this.dateFormVisible = false
            this.getDateRule()
          }
        })
      },

      deleteDateRule(){
        del_meter_cut_instant_rule({id:this.curId}).then(res => {
          if(res.status == 1){
            this.$message.success('操作成功!')

            this.getDateRule()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      handelDeleRule(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.curId = row.id
          this.deleteDateRule()
        })
      },

      handelDateRuleWallet(row){

        this.setFormVisible = true
        this.curId = row.id
        this.formInline.depId = this.depId
        this.getWalletList()
      },

      getWalletList(){
        let param = {
          ruleType:this.dtype[this.dataType],
          ruleId:this.curId
        }
        list_wallet_by_rule(param).then(res => {
          if(res.status == 1){
             this.walletList = res.data
          }
        })
      },





      handelAddWallet(){
        this.walletLoad = true
        this.walletVisible = true
        this.formInline.walletName = ''
        this.getAllWalletList()
      },

      getAllWalletList(){
        walletSelectByDptId2(this.formInline).then(res => {
          this.walletLoad = false
          if(res.status == 1){
            this.allWalletList = res.data.data
          }

        })
      },


      getwalletIds(e){
        this.walletIds = e
      },
      getMeterIds(e){
        this.meterIds = e
      },

      getDeleWalletIds(e){
        this.selectWallet = e
      },
      getDeleMeterIds(e){
        this.selectMeter = e
      },


      //绑定钱包
      saveBindWallet(){
        this.setLoading = true
        let param = {
          ruleId:this.curId,
          walletIds:this.walletIds.map(item => item.id)
        }

        if(this.dataType == 0){
          //拉闸时间点规则绑定钱包
          meter_cut_instant_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.walletVisible = false
              this.getWalletList()
              // this.getDateRule()
            }
          })
        }else if( this.dataType == 1 ){
          //拉闸阈值规则绑定钱包
          meter_threshold_instant_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.walletVisible = false
              this.getWalletList()
              // this.getYuZhi()
            }
          })
        }else{

          meter_recording_rule_bind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.walletVisible = false
                this.getWalletList()
               // this.getChaobiao()
            }
          })
        }

      },

      removeBindWallet(){
        this.setLoading = true
        let param = {
          ruleId:this.curId,
          walletIds:this.selectWallet.map(item => item.id)
        }


        if(this.dataType == 0){
          meter_cut_instant_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
               this.getWalletList()
              //this.getDateRule()
            }else{
              this.$message.error(res.msg)
            }
          })
        }else if(this.dataType == 1){
          meter_threshold_instant_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
               this.getWalletList()
             //this.getYuZhi()
            }else{
              this.$message.error(res.msg)
            }
          })
        }else{
          meter_recording_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
               this.getWalletList()
              //this.getChaobiao()
            }else{
              this.$message.error(res.msg)
            }
          })
        }

      },


      //拉闸阈值规则

      handelAddYuZhi(){
        this.yuZhiFormVisible = true
        this.yuZhiFrom.id = ''
        this.yuZhiFrom.threshold = ''
        if( this.depId != 0  ){
           this.yuZhiFrom.defaultFlag = false
        }

      },

      getYuZhi(){
        this.loading = true
        list_meter_cut_threshold_rule(this.yuZhiGet).then(res => {
           this.loading = false
          if(res.status == 1){
            this.yuZhiList = res.data.content
            this.yuZhiGet.total = res.data.totalElements
          }
        })
      },

      saveYuzhi(){
        if(this.DateTitle == '添加'){
          this.addYuZhi()
        }else{
          this.updateYuzhi()
        }
      },


      handelYuZhi(row){
        this.DateTitle = '修改'
        this.yuZhiFormVisible = true

        this.yuZhiFrom.id = row.id
        this.yuZhiFrom.threshold = row.threshold


        this.yuZhiFrom.defaultFlag = row.defaultFlag

      },

      addYuZhi(){
        add_meter_cut_threshold_rule(this.yuZhiFrom).then(res => {
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.yuZhiFormVisible = false
            this.getYuZhi()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      updateYuzhi(){
        update_meter_cut_threshold_rule(this.yuZhiFrom).then(res => {
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.yuZhiFormVisible = false
            this.getYuZhi()
          }
        })
      },

      handelDeleyuZhi(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.curId = row.id
          this.deleteYuzhi()
        })
      },

      deleteYuzhi(){
        del_meter_cut_threshold_rule({id:this.curId}).then(res => {
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.getYuZhi()
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      //抄表时间点规则

      getChaobiao(){
        this.loading = true
        list_meter_recording_rule(this.chaoBiaoGet).then(res => {
           this.loading = false
          if(res.status == 1){
            this.chaoBiaoList = res.data.content
            this.chaoBiaoGet.total = res.data.totalElements
          }
        })
      },

      handelAddChaobiao(){
        this.chaoBiaoFormVisible = true
        this.chaobaioFrom.id = ''
        this.chaobaioFrom.instant =  "15:00"

        if( this.depId != 0  ){
            this.chaobaioFrom.defaultFlag = false
        }

      },

      handelChaobiaoDetail(row){
        this.chaobaioFrom.id = row.id
        this.chaobaioFrom.defaultFlag = row.defaultFlag

        this.chaobaioFrom.instant = row.instant
        this.chaoBiaoFormVisible = true
      },

      saveChaoBiao(){
        if(this.DateTitle == '添加'){
          this.addChaobiao()
        }else{
          this.updateChaobiao()
        }
      },

      addChaobiao(){
        console.log(this.chaobaioFrom)
        add_meter_recording_rule(this.chaobaioFrom).then(res => {
          if(res.status == 1 ){
            this.$message.success('操作成功！')
            this.chaoBiaoFormVisible = false
            this.getChaobiao()
          }
        })
      },

      updateChaobiao(){
        update_meter_recording_rule(this.chaobaioFrom).then(res => {
          if(res.status == 1 ){
            this.$message.success('操作成功！')
            this.chaoBiaoFormVisible = false
            this.getChaobiao()
          }else{
            this.$message.err(res.msg)
          }
        })
      },

      handelDeleChaobiaoRule(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.curId = row.id
          del_meter_recording_rule({id:row.id}).then(res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getChaobiao()
            }else{
              this.$message.error(res.msg)
            }
          })
        })
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/prepayment/switchSet.vue